import jsPDF from "jspdf";
import { PdfElement } from "@src/app/interfaces/pdf.interface";

export class PdfTextElement implements PdfElement {
    private text: string;
    public readonly newPage: boolean;

    constructor(text: string, newPage: boolean = false) {
      this.text = text;
      this.newPage = newPage;
    }

    public async render(doc: jsPDF, x: number, y: number, maxWidth: number): Promise<number> {
      const lines = doc.splitTextToSize(this.text, maxWidth);
      doc.text(lines, x, y);

      const fontSize = doc.getFontSize();
      const lineHeightFactor = 1.15;
      const usedHeight = lines.length * fontSize * lineHeightFactor;
      return usedHeight;
    }

}
